export const BACKOFFICE_QUERIES = {
  COMPANIES: "BACKOFFICE_COMPANIES",
  COMPANY_PLANS_BY_SELLER: "BACKOFFICE_COMPANY_PLANS_BY_SELLER",
  TERMINALS: "TERMINALS",
  TERMINAL_DETAILS: "TERMINAL_DETAILS",
} as const;